import { useEffect, useState } from "react";
import CommonAPI from "../API/common";
import {
  SITE_COMPANY_INFO_DEFAULTS,
  resolveSiteCode,
} from "../const/siteCompanyInfo";

export default function useSiteCompanyInfo() {
  const [info, setInfo] = useState(SITE_COMPANY_INFO_DEFAULTS);

  useEffect(() => {
    let alive = true;
    CommonAPI.getSiteCompanyInfo(resolveSiteCode())
      .then((res) => {
        if (!alive || !res?.data) return;
        setInfo({ ...SITE_COMPANY_INFO_DEFAULTS, ...res.data });
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  return info;
}
